/* global AmCharts */

AmCharts.themes.light.AmChart['fontFamily'] = 'Open Sans, sans serif';
AmCharts.themes.light.AmChart['fontSize'] = 12;
AmCharts.themes.light.AmChart['color'] = '#3e3f68';

AmCharts.themes.boc.AmChart['fontFamily'] = 'Open Sans, sans serif';
AmCharts.themes.boc.AmChart['fontSize'] = 12;
AmCharts.themes.boc.AmChart['color'] = '#3e3f68';

AmCharts.themes.bocDark.AmChart['fontFamily'] = 'Open Sans, sans serif';
AmCharts.themes.bocDark.AmChart['fontSize'] = 12;
AmCharts.themes.bocDark.AmChart['color'] = 'hsl(0, 0%, 90%)';
